import { useNavigate } from 'react-router-dom';
import { MOCK_ROWS } from '../data/mockBooks';
import { StatusBadge } from '../components/StatusBadge';
import { RiskBadge } from '../components/RiskBadge';

interface ListViewProps {
  tab: string;
}

export function ListView({ tab }: ListViewProps) {
  const nav = useNavigate();
  const rows = MOCK_ROWS;

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <div
        style={{
          padding: '14px 24px',
          borderBottom: '1px solid var(--a-line)',
          background: 'var(--a-card)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div
            style={{
              fontSize: 11,
              color: 'var(--a-ink-mute)',
              fontFamily: 'var(--mono)',
              letterSpacing: 1,
            }}
          >
            BÜCHER · {tab.toUpperCase()}
          </div>
          <h1
            style={{
              fontFamily: 'var(--sans)',
              fontSize: 18,
              fontWeight: 700,
              margin: '2px 0 0',
              color: 'var(--a-ink)',
            }}
          >
            {tab}{' '}
            <span style={{ color: 'var(--a-ink-mute)', fontWeight: 500 }}>· {rows.length}</span>
          </h1>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '7px 12px',
              border: '1px solid var(--a-line)',
              borderRadius: 6,
              gap: 8,
              fontSize: 12,
              color: 'var(--a-ink-mute)',
              background: 'var(--a-card)',
              minWidth: 240,
            }}
          >
            <span>⌕</span>
            <span>Suchen Buch-ID, E-Mail, Order …</span>
            <span
              style={{
                marginLeft: 'auto',
                fontFamily: 'var(--mono)',
                fontSize: 10,
                padding: '1px 5px',
                background: 'var(--a-line-soft)',
                borderRadius: 3,
              }}
            >
              ⌘K
            </span>
          </div>
          <button
            style={{
              padding: '7px 14px',
              borderRadius: 6,
              fontSize: 12,
              color: '#fff',
              background: 'var(--a-ink)',
              border: 0,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Export CSV
          </button>
        </div>
      </div>

      <div
        style={{
          padding: '12px 24px',
          display: 'grid',
          gridTemplateColumns: 'repeat(5, 1fr)',
          gap: 8,
          background: 'var(--a-bg)',
          borderBottom: '1px solid var(--a-line)',
        }}
      >
        {[
          { l: 'Heute neu bezahlt', v: '12', d: '+3 vs. gestern', c: 'var(--a-green)' },
          { l: 'Brauchen Review', v: '4', d: '1 dringend', c: 'var(--a-amber)' },
          { l: 'In Korrektur', v: '1', d: 'Antwort offen', c: 'var(--a-red)' },
          { l: 'Bereit zum Druck', v: '3', d: 'PDF generiert', c: 'var(--a-blue)' },
          { l: 'Conversion (7d)', v: '2,4 %', d: 'Preview → Kauf', c: 'var(--a-violet)' },
        ].map((s, i) => (
          <div
            key={i}
            style={{
              background: 'var(--a-card)',
              border: '1px solid var(--a-line)',
              borderRadius: 8,
              padding: '10px 14px',
            }}
          >
            <div
              style={{
                fontSize: 10,
                color: 'var(--a-ink-mute)',
                letterSpacing: 0.5,
                fontFamily: 'var(--mono)',
              }}
            >
              {s.l.toUpperCase()}
            </div>
            <div
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: 'var(--a-ink)',
                marginTop: 2,
              }}
            >
              {s.v}
            </div>
            <div style={{ fontSize: 11, color: s.c, fontWeight: 600 }}>{s.d}</div>
          </div>
        ))}
      </div>

      <div style={{ flex: 1, overflow: 'auto', background: 'var(--a-card)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: 'var(--a-bg)', borderBottom: '1px solid var(--a-line)' }}>
              {['', 'Book ID', 'Customer', 'Story', 'Plushies', 'Status', 'IP Risk', 'Order', 'Created', ''].map(
                (h, i) => (
                  <th
                    key={i}
                    style={{
                      padding: '10px 14px',
                      textAlign: 'left',
                      fontSize: 10,
                      fontWeight: 600,
                      color: 'var(--a-ink-mute)',
                      letterSpacing: 1,
                      fontFamily: 'var(--mono)',
                    }}
                  >
                    {h}
                  </th>
                ),
              )}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr
                key={r.id}
                onClick={() => nav(`/books/${r.id}`)}
                style={{
                  borderBottom: '1px solid var(--a-line-soft)',
                  cursor: 'pointer',
                }}
              >
                <td style={{ padding: '12px 14px' }}>
                  <input type="checkbox" onClick={(e) => e.stopPropagation()} />
                </td>
                <td
                  style={{
                    padding: '12px 14px',
                    fontFamily: 'var(--mono)',
                    fontSize: 12,
                    fontWeight: 600,
                    color: 'var(--a-ink)',
                  }}
                >
                  {r.id}
                </td>
                <td style={{ padding: '12px 14px', color: 'var(--a-ink-soft)' }}>{r.email}</td>
                <td style={{ padding: '12px 14px', color: 'var(--a-ink-soft)' }}>{r.story}</td>
                <td style={{ padding: '12px 14px', color: 'var(--a-ink)' }}>
                  {r.plush}{' '}
                  <span style={{ color: 'var(--a-ink-mute)' }}>· {r.count}</span>
                </td>
                <td style={{ padding: '12px 14px' }}>
                  <StatusBadge status={r.status} />
                </td>
                <td style={{ padding: '12px 14px' }}>
                  <RiskBadge level={r.risk} />
                </td>
                <td
                  style={{
                    padding: '12px 14px',
                    fontFamily: 'var(--mono)',
                    color: 'var(--a-blue)',
                    fontSize: 11,
                  }}
                >
                  {r.order}
                </td>
                <td style={{ padding: '12px 14px', color: 'var(--a-ink-mute)', fontSize: 11 }}>
                  {r.date}
                </td>
                <td style={{ padding: '12px 14px', textAlign: 'right' }}>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      nav(`/books/${r.id}`);
                    }}
                    style={{
                      padding: '4px 10px',
                      border: '1px solid var(--a-line)',
                      borderRadius: 5,
                      background: 'var(--a-card)',
                      fontSize: 11,
                      fontWeight: 600,
                      color: 'var(--a-ink-soft)',
                      cursor: 'pointer',
                    }}
                  >
                    Öffnen
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
